import Dialog, { DialogHeading, DialogHeadingText, CloseIcon } from './Dialog'
import { P } from './TextComponents'
import styled from 'styled-components'
import clickSaveDraft from '../lib/click-save-draft'
import { useAppConfig } from '../providers/AppConfigProvider'
import { SaveDraftButton } from './Page'

interface Props {
  fetchMaintenanceWindowError?: string
  clearMaintenanceMessage: () => void
}

const ButtonsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding-top: ${({ theme }) => theme.unit / 2}px}
`

export default function MaintenanceModel({
  fetchMaintenanceWindowError,
  clearMaintenanceMessage,
}: Props) {
  const { buttons } = useAppConfig()

  return (
    <Dialog isOpen={!!fetchMaintenanceWindowError}>
      <DialogHeading>
        <DialogHeadingText>We could not submit your form</DialogHeadingText>
        <CloseIcon onClick={clearMaintenanceMessage} />
      </DialogHeading>
      <>
        <P>
          We could not submit your form due to system maintenance, but you can
          still save a draft.
        </P>
      </>
      <P>
        Maintenance Message: <i>{fetchMaintenanceWindowError}</i>
      </P>
      <ButtonsContainer>
        <div>
          <SaveDraftButton
            className="button ob-button is-primary ob-button-save-draft"
            saveDraft={() => clickSaveDraft(clearMaintenanceMessage)}
            buttons={buttons}
          />
        </div>
        <button
          type="button"
          className="button ob-button is-primary"
          onClick={clearMaintenanceMessage}
        >
          Close
        </button>
      </ButtonsContainer>
    </Dialog>
  )
}
